const AccountStatus = {
  Active: 'active',
  Inactive: 'inactive'
};

export default AccountStatus;
